import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { NGAUGE_PROPERTY_LOG_INFO, USER_INFO } from '../../util/constants';
import { LogAuditApi, LogConsole, LogLocalStorage, LogPublisher, LogWebApi } from './log-publishers';
import { LogService } from './log.service';
import { NGaugeService } from './ngauge.service';
const PUBLISHERS_FILE = 'assets/log-publishers.json';

@Injectable()
export class LogPublishersService {

  publishers: LogPublisher[] = [];

  constructor(
    private http: HttpClient,
    private logService: LogService,
    private ngaugeService: NGaugeService) { }

  buildPublishers(): void {
    let logPub: LogPublisher;
    this.getLoggers().subscribe(response => {
      response = this.ngaugeService.isJSON(response);
      for (const pub of response.filter(p => p.isActive)) {
        switch (pub.loggerName.toLowerCase()) {
          case 'console':
            logPub = new LogConsole();
            break;
          case 'localstorage':
            logPub = new LogLocalStorage();
            break;
          case 'clientlog':
            logPub = new LogWebApi(this.http, pub.loggerLocation);
            break;
          case 'auditlog':
            logPub = new LogAuditApi(this.http, pub.loggerLocation);
            break;
          case 'fieldhistory':
            logPub = new LogWebApi(this.http, pub.loggerLocation);
            break;
        }
        // Set location of logging
        logPub.location = pub.loggerLocation;
        // Add publisher to array
        this.publishers.push(logPub);
        this.logService.publishers = this.publishers;
      }
    }, error => {
      console.error(' Unable to read Logger Configuration file from ' + PUBLISHERS_FILE);
    });
  }

  getLoggers(): Observable<any> {
    const user = JSON.parse(sessionStorage.getItem(USER_INFO));
    if (user === null) {
      return this.http.get(PUBLISHERS_FILE).map(res => {
        return res;
      });
    } else {
      sessionStorage.removeItem(NGAUGE_PROPERTY_LOG_INFO);
      const logConfig = sessionStorage.getItem(NGAUGE_PROPERTY_LOG_INFO);
      const meldUrl = this.ngaugeService.meldURL;
      if (logConfig === null) {
        if (meldUrl !== undefined) {
          const whereCondition = '"where": {"name": "' + user.property + '"}';
          const fields = '"fields":["id", "logconfig", "name"]';
          const filter = '{' + whereCondition + ',' + fields + '}';
          const params = { params: this.ngaugeService.getHttpParams(filter) };
          return this.http.get(this.ngaugeService.getMeldURL('GET_PROPERTY_LIST'), params).map(res => {
            if (res[0]['logconfig'] !== undefined) {
              sessionStorage.setItem(NGAUGE_PROPERTY_LOG_INFO, JSON.stringify(res[0]['logconfig']));
              return res[0]['logconfig'];
            } else {
              return this.http.get(PUBLISHERS_FILE).map(resp => {
                return resp;
              });
            }
          });
        } else {
          return this.http.get(PUBLISHERS_FILE).map(res => {
            return res;
          });
        }
      } else {
        sessionStorage.setItem(NGAUGE_PROPERTY_LOG_INFO, JSON.stringify(logConfig));
        return Observable.of<any>(logConfig);
      }
    }
  }
}

class LogPublisherConfig {
  loggerName: string;
  loggerLocation: string;
  isActive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/services/shared/log-publishers.service.ts